import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'
import { StatesConfig } from 'xstate'
import { useZustandStore as useZustandGlobalStore } from 'zustandGlobalStore'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { getHasPaidUpsell } from 'nove8/helpers/getHasPaidUpsell'
import { useZustandGlobalSessionStore } from 'zustandGlobalSessionStore'

const getHasUpsell = () =>
  getHasPaidUpsell(useZustandGlobalStore.getState().lead?.purchases || null)
const getHasInvoxiaFormSubmitted = () =>
  useZustandGlobalSessionStore.getState().hasInvoxiaFormSubmitted

export const getXStateConfigWoofzInvx = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    // Pay attention to the order of the conditions!
    always: [
      // Cover case when page was reloaded or connection was lost
      // during the purchase polling
      {
        cond: (): boolean => !!useZustandGlobalLocalStore.getState().purchaseId,
        target:
          useZustandGlobalLocalStore.getState().purchasePageId ||
          pages[0].pageId,
      },
      {
        cond: (): boolean => {
          const hasUpsell = getHasUpsell()
          return !!hasUpsell
        },
        target: getHasInvoxiaFormSubmitted()
          ? PageId.INVOXIA_DETAILS_INVX
          : PageId.INVOXIA_CONGRATULATIONS_INVX,
      },
      {
        target: pages[0].pageId, // Always transition to first page as fallback
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
        },
      },
    }),
    {},
  ),
  [PageId.INVOXIA_DETAILS_INVX]: {
    type: 'final',
  },
})
